export default {"src":"/_next/static/image/src/images/portable-logo.ead796a488306cee22e4a22dac70e228.svg","height":30,"width":168};